//import firebase from "firebase"
import Vue from "vue";
import VueRouter from "vue-router";
import Admin from "../components/Admin.vue";
import Login from "../components/Login.vue";
import Videos from "../components/Videos.vue";
import Ads from "../components/Ads.vue";
import Batches from "../components/Batches.vue";
import CreativeDirections from "../components/CreativeDirections.vue";
import Client from "../components/Client.vue";
//import store from '../store.js'
import Firebase from 'firebase/app';

require('firebase/firestore');

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/c',
      component: Client,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '/',
          meta: {
            requiresAuth: true
          }
        },
        {
          path: ':id',
          redirect: ':id/videos',
          meta: {
            requiresAuth: true
          }
        },
        {
          name: 'videos',
          path: ':id/videos',
          component: Videos,
          meta: {
            requiresAuth: true
          }
        },
        {
          name: 'batches',
          path: ':id/delivery_batches',
          component: Batches,
          meta: {
            requiresAuth: true
          }
        },
        {
          name: 'creative directions',
          path: ':id/creative_directions',
          component: CreativeDirections,
          meta: {
            requiresAuth: true
          }
        },
        {
          name: 'ads',
          path: ':id/ads',
          component: Ads,
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      name: "home",
      path: "/",
      redirect: '/c',
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/admin",
      name: "admin",
      component: Admin,
      meta: {
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  const currentUser = Firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  //const userClaims = (Object.keys(store.state.currentUserClaims).length > 0)
  //const clientList = (Object.keys(store.state.clientCollection).length > 0)
  //const selectedClient = store.state.selectedClient
  if (requiresAuth && !currentUser) {

    next('/login');
  } else {
    next()
  }


});

export default router;
